<template>
  <app-form
    ref="form"
    :data="data"
    :schema="schema"
    :layout="layout"
    @on-submit="onSubmit"
    @on-input="onFormFieldChanged"
    @on-input-modified="onFormFieldModified"
  >
    <template v-slot:default>
      <slot name="default"/>
    </template>
    <template v-slot:tax-agent-staff-info-title>
      <app-form-sub-title>{{ $t('vat.tax-agent-staff').toUpperCase() }}</app-form-sub-title>
    </template>
  </app-form>
</template>
<script>
import AppForm from '@/components/app-form';
import AppFormSubTitle from '@/components/app-form/form-sub-title';
import { data, schema, layout } from './index';

export default {
  name: 'VatReturnForm',
  components: { AppForm, AppFormSubTitle },
  data() {
    return {
      data: {
        ...data,
      },
      layout: {
        ...layout,
      },
      schema: {
        ...schema(this),
      },
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.initialize();
    });
  },
  methods: {
    initialize() {
      this.initFormModel();
      if (this.$refs.form) {
        this.$refs.form.initialize(this.data);
      }
    },

    initFormModel() {
      this.data = Object.assign({}, this.data);
    },

    onFormFieldChanged($event, field) {},

    onFormFieldModified(isChanged) {
      this.$emit('on-input-modified', isChanged);
    },

    onSubmit(formModel, validate, { resolve, reject }) {
      this.$refs.form.validate().then((isValid) => {
        if (isValid) {
          this.$emit('on-submit', formModel, validate, { resolve, reject });
        }
      });
    },

    submit() {
      return this.$refs.form.submit();
    },

    validate() {
      return this.$refs.form.validate();
    },

    getValues() {
      return this.$refs.form.getValues();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/portal-components/value-added-tax/vat-return/vat-return-form/vat-return-form.vue